import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import insitu_haz_lev from "../img/sswpIcons/InSiteWorks/insitu_haz_lev.png";
import insitu_con_pou from "../img/sswpIcons/InSiteWorks/insitu_con_pou.png";
import insitu_con_pok from "../img/sswpIcons/InSiteWorks/insitu_con_pok.png";
import insitu_for_tab from "../img/sswpIcons/InSiteWorks/insitu_for_tab.png";
import insitu_gua_all_ope from "../img/sswpIcons/InSiteWorks/insitu_gua_all_ope.png";
import insitu_pro_sup from "../img/sswpIcons/InSiteWorks/insitu_pro_sup.png";
import insitu_pro_edg_pro from "../img/sswpIcons/InSiteWorks/insitu_pro_edg_pro.png";
import insitu_pro_wor_pla from "../img/sswpIcons/InSiteWorks/insitu_pro_wor_pla.png";
import insitu_ste_fix from "../img/sswpIcons/InSiteWorks/insitu_ste_fix.png";
import insitu_str from "../img/sswpIcons/InSiteWorks/insitu_str.png";
import insitu_tem_wor from "../img/sswpIcons/InSiteWorks/insitu_tem_wor.png";
import insitu_reb from "../img/sswpIcons/InSiteWorks/insitu_reb.png";
import insitu_sit_spe_met from "../img/sswpIcons/InSiteWorks/insitu_sit_spe_met.png";

const json = {
    icon: insitu_haz_lev,
    name: "In-Situ Works",
    text: "",
    icons: {
        insitu_gua_all_ope: {
            name: "Open Holes/ Openings",
            icon: insitu_gua_all_ope,
            text: (
                <ul>
                    <ListItem
                        text="All openings (open manholes etc) must be guarded to prevent falls. This should be done using barriers.
"
                    />
                    <ListItem text="The opening should be closed or backfilled as soon as practicable." />
                    <ListItem text="When using covers, these must be set flush too, and fixed to the surrounding surface. They should have a textured surface to EN 124 (minimum 2mm) or high friction surface to USRV 35, and be strong enough for the potential loading." />
                </ul>
            )
        },
        insitu_pro_sup: {
            name: "Propping",
            icon: insitu_pro_sup,
            text: (
                <ul>
                    <ListItem text="Propping may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="Propping with soldier sets is a simple form of trench support set which can be formed with steel or timber. This system is mostly used in rock, stiff clays and in other soil types with similar self-supporting properties. " />
                    <ListItem text="Unlike shoring, soldier sets retain the earth where there may be a fault in the embankment. Soldier sets only provide ground support at regular intervals and do not provide positive ground support to the whole excavated face. Open soldier sets are only suitable for use in stable soil types." />
                    <Li>
                        <Typography variant="title">
                            The following guidelines should be followed
                        </Typography>
                        <ol>
                            <ListItem text="Keep spoil at least 600mm from edge" />
                            <ListItem text="Soldiers (vertical side element) should protrude at least 500mm above top of trench" />
                            <ListItem text="Top Tom (cross-support) should be no lower than 300mm from trench top" />
                            <ListItem text="Maximum spacing between Toms no more than 750mm" />
                            <ListItem text="All jointing should be secured with nails/screws" />
                            <ListItem text="Maximum spacing between Soldiers 1.5m" />
                            <ListItem text="Minimum size of Soldier 150x38mm" />
                            <ListItem text="Minimum size of Tom 150x38mm" />
                            <ListItem text="Tom needs to be long enough to force Soldier firmly against trench side" />
                            <ListItem text="Space between bottom Tom and trench floor should allow for pipe, generally not more than 1m." />
                        </ol>
                    </Li>
                    <ListItem text="Propping can be adaptable, particularly when working around existing services and can be quick to install especially in shallow excavations." />
                    <ListItem text="It requires considerable experience and skill to install, with each arrangement requiring bespoke design." />
                </ul>
            )
        },
        insitu_pro_edg_pro: {
            name: "Proprietary Edge Protection",
            icon: insitu_pro_edg_pro,
            text: (
                <ul>
                    <ListItem text="Provided with decking systems or form tables." />
                    <ListItem text="Should consist of uprights which will clamp on, along with guard rails and toe boards." />
                    <ListItem text="You must be trained in how to install these correctly and in accordance with the manufacturer’s instructions" />
                </ul>
            )
        },
        insitu_pro_wor_pla: {
            name: "Proprietary Work Platform",
            icon: insitu_pro_wor_pla,
            text: (
                <ul>
                    <ListItem text="Provided with proprietary falsework systems" />
                    <ListItem text="Must use associated safe ladder access, guard rails and toe boards." />
                    <ListItem text="You must be trained in how to install these correctly and in accordance with the manufacturer’s instructions" />
                </ul>
            )
        },
        insitu_tem_wor: {
            name: "Temporary Works",
            icon: insitu_tem_wor,
            text: (
                <ul>
                    <ListItem text="Temporary works are structures (including groundwork formation, trench support, scaffolds etc) that are temporarily used to construct permanent structures, and are removed on works completion." />
                    <ListItem text="Other than for standard solutions used in low risk situations, Temporary works generally require formal design by a competent person and a Temporary Works Design/Check certificate." />
                    <Li>
                        <Typography variant="title">
                            On site, temporary works will require a Temporary
                            Works Coordinator (who is generally different to the
                            temporary works designer) to oversee and manage the
                            processes used during temporary works. They must be
                            competent (usually with a structural/civil
                            engineering degree) and have appropriate training.
                            Their duties should include{" "}
                        </Typography>
                        <ol>
                            <ListItem text="maintaining a temporary works register, and" />
                            <ListItem text=" ensuring that pre-erection inspections are carried out on temporary works materials and components, and" />
                            <ListItem text="Check that temporary works have been erected in accordance with the design, and issue “permit to load/work” where necessary, and" />
                            <ListItem text="Get confirmation that permanent structure has attained adequate strength before dismantling the temporary works" />
                        </ol>
                    </Li>
                    <ListItem text="A Temporary Works Supervisor may be appointed to assist the Temporary Works Coordinator." />
                </ul>
            )
        },
        insitu_for_tab: {
            name: "Form Tables",
            icon: insitu_for_tab,
            text: (
                <ul>
                    <ListItem text="Proprietary form tables should be supplied with proprietary lifting attachments. These must be used, and NOT replaced with alternatives." />
                    <Li>
                        <Typography variant="title">
                            Ensure a proper exclusion zone is put in place when
                            moving form tables
                        </Typography>
                        <ol>
                            <ListItem text="Near edges of slabs – around the form table" />
                            <ListItem text="Between building levels – below the form table" />
                        </ol>
                    </Li>
                    <ListItem text="Form tables should not be moved in heavy winds." />
                </ul>
            )
        },
        insitu_con_pok: {
            name: "Concrete Poker",
            icon: insitu_con_pok,
            text: (
                <ul>
                    <ListItem text="Risk is health effect by exposure to vibrating tool" />
                    <ListItem text="Equipment must be well maintained and in good working order" />
                    <ListItem text="Rotate operatives at regular intervals/ have sufficient rest periods" />
                    <ListItem text="Do not eat, drink or smoke while using the tool." />
                    <ListItem text="Ensure you have a good grip of the tool and are standing securely when starting and using the tool. " />
                    <ListItem text="Eye protection, hearing protection and gloves must be worn. Washable or disposable protective clothing should be worn." />
                    <ListItem text="Ensure your First Aid Kit has eye-wash." />
                </ul>
            )
        },
        insitu_reb: {
            name: "Rebar",
            icon: insitu_reb,
            text: (
                <ul>
                    <ListItem text="Exposed rebar, particularly on access routes or in work areas, must be removed fully by cutting, bent away, or capped with plastic mushroom caps to prevent puncture injuries and trips." />
                </ul>
            )
        },
        insitu_ste_fix: {
            name: "Steel Fixings",
            icon: insitu_ste_fix,
            text: (
                <ul>
                    <ListItem text="Should be organised to prevent manual handling injury (work done at waist height, on raised platforms, to avoid continual bending." />
                    <ListItem text="Should be done at ground level and then lifted into position." />
                    <ListItem text="Assess risks, and use appropriate controls to prevent slips, trips and puncture injuries. Also assess risks associated with having to walk across the mesh, and if possible eliminate this activity. Introduce storage areas and (sheeted) walkways to avoid this risk." />
                    <ListItem text="Keep the area clean and tidy, free from excess tools and equipment." />
                    <ListItem text="Ensure that any electric tools or connections are sufficiently isolated from the mesh." />
                    <ListItem text="Use appropriate controls for lifting and cutting activities. You should not be within 15m of combustible or flammable materials." />
                    <ListItem text="Do not use excess pressure when twisting wire manually (prevent kick back), and always maintain control of the free end. Use the correct tying wire and do not carry excess amounts of wire." />
                    <ListItem text="Use hard hats, eye and glove PPE. Gloves should be of flexible leather type, or equivalent. Do not handle ends of bars (sharp edges)." />
                </ul>
            )
        },
        insitu_con_pou: {
            name: "Concrete Pour",
            icon: insitu_con_pou,
            text: (
                <ul>
                    <ListItem text="Prevent concrete from coming in contact with body by using overalls, gloves, high boots/wellies, and safety goggles." />
                    <ListItem text="Do not eat, drink or smoke while undertaking works." />
                    <ListItem text="Ensure you have a good supply of water in the event of spills." />
                    <ListItem text="Ensure that your First Aid Kit has eye-wash." />
                </ul>
            )
        },
        insitu_str: {
            name: "Strikings",
            icon: insitu_str,
            text: (
                <ul>
                    <ListItem text="All work activity on the building needs to be complete before striking commences. Associated tools, materials and equipment need to be removed." />
                    <ListItem text="All components need to be removed and lowered in a planned and systematic way. The integrity of the formwork structure and supports needs to be maintained during the removal." />
                    <ListItem text="No loose boards/parts should be left in place. Assess removed items for hazards and remove protruding nails etc. immediately." />
                    <ListItem text="If removing formwork near building edges, ensure there is no risk of workers falling over edges. You will require adequate controls to be selected." />
                    <ListItem text="Propping and decking components should be placed in the designated storage area immediately. This area, and it’s access routes, should be kept clean and organised to prevent trips." />
                    <ListItem text="Do not strike in heavy winds" />
                </ul>
            )
        },
        insitu_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: insitu_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
